import { render, staticRenderFns } from "./FreeSizerBlock.vue?vue&type=template&id=23ac2dfc&"
import script from "./FreeSizerBlock.vue?vue&type=script&lang=js&"
export * from "./FreeSizerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports